import styled from "styled-components";

export const HomeViewWrapper = styled.div`
padding:3rem;
max-width:100%;
overflow:auto;
// Unitar Resource Popup
.unitar-resource-main-wrapper{
  .unitar-resource-pop-wrapper{
    position: fixed;
    bottom: 4rem;
    right: 3rem;
    width: 31rem;
    max-height: 40rem;
    transform: translateY(0);
    transition: 0.6s all ease;
    z-index: 99;
    &.active-min-class{
      transform: translateY(1000px);
      transition: 0.6s all ease;
    }
    @media(max-width: 740px){
      bottom: 40px;
      right: 5px;
    }
    .unitar-resource-pop-card{
      display: flex;
      flex-direction: column;
      gap: 2rem;
      background-color: #f7fafe;
      padding: 1rem;
      border-top-left-radius: 0.4rem;
      border-top-right-radius: 0.4rem;
      .unitar-resource-pop-header{
        display: flex;
        align-items: center;
        justify-content: space-between;
        .unitar-pop-head-left{
          display: inline-flex;
          align-items: center;
          .uni-cir-img{
            height: 4.8rem;
            width: 4.8rem;
            i{
              display: inline-block;
              width: 100%;
              height: 100%;
              svg{
                height: 100%;
                width: 100%;
              }
            }
          }
          .unitar-text{
            padding-left: 1.2rem;
            .bold-text{
              display: block;
              color: #000;
              font-size: 1.8rem;
              font-weight: 600;
              line-height: normal;
              padding-bottom: 8px;
            }
            .sub-text{
              display: block;
              color: #4A4A4A;
              font-size: 1.4rem;
              font-weight: 300;
              line-height: normal;
            }
          }
        }
        .unitar-min-btn{
          display: inline-block;
          height: 2.4rem;
          width: 2.4rem;
          i{
            display: inline-block;
            height: 100%;
            width: 100%;
            svg{
              height: 100%;
              width: 100%;
            }
          }
          &:hover{
            svg{
              rect{
                fill:#E2EEFA;
              }
            }
          }
        }
      }
      .unitar-resource-pop-body{
        display: flex;
        flex-direction: column;
        gap: 2rem;
        .image-container{
          position: relative;
          width: 100%;
          .banner-img{
            display: inline-block;
            height: 100%;
            width: 100%;
            svg{
              height: 100%;
              width: 100%;
            }
          }
          .uni-play-btn{
            display: inline-block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            height: 4.7rem;
            width: 4.7rem;
            i{
              display: inline-block;
              height: 100%;
              width: 100%;
              svg{
                height: 100%;
                width: 100%;
              }
            }
          }
        }
        p{
          color: #4A4A4A;
          font-size: 1.4rem;
          font-style: normal;
          font-weight: 400;
          line-height: 2rem; /* 142.857% */
        }
      }
      .unitar-resource-pop-footer{
        padding-bottom: 3rem;
        .unitar-view-link{
          display: inline-block;
          border-radius: 0.4rem;
          background: #3D90DD;
          padding: 0.8rem 2rem;
          color: #FFF;
          font-size: 1.4rem;
          font-style: normal;
          font-weight: 500;
          line-height: 1.8rem;
          letter-spacing: 0.028rem;
          border: 0;
        }
      }
    }
  }
  .unitar-max-btn{
    color: #FFF;
    font-size: 1.4rem;
    font-weight: 400;
    line-height: 1.8rem; /* 128.571% */
    letter-spacing: 0.028rem;
    border-radius: 0.4rem 0.4rem 0px 0px;
    background: #3D90DD;
    padding: 1.2rem 2rem;
    position: fixed;
    bottom: 0;
    right: 3rem;
    transform: translateY(200px);
    transition: 0.5s all ease-in;
    &.active-max-class{
      transition: 0.5s all ease-out;
      transform: translateY(0);
    }
    b{
      font-weight: 600;
    }
  }
}
// Unitar Video Popup
.unitar-video-pop-wrapper{
  position: fixed;
  height: 100%;
  width: 100%;
  background: rgba(125, 134, 140, 0.30);
  backdrop-filter: blur(2px); 
  z-index: 100;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  .unitar-video-pop-wrap{
    min-height: 53.2rem;
    width: 95rem;
    left: 50%;
    transform: translate(-50%, -50%);
    top: 50%;
    position: absolute;
    display: flex;
    flex-direction: column;
    border-radius: 1.2rem;
    background: #FFF;
    box-shadow: 0px 0px 0.8rem 0px rgba(21, 27, 38, 0.12);
    padding: 2.4rem;
    gap: 1.2rem;
    @media(max-width: 900px){
      width: calc(100% - 20px);
      min-height: 200px;
    }
    .unitar-video-pop-head{
      display: flex;
      justify-content: space-between;
      align-items: center;
      .unitar-video-title{
        color: #000;
        font-size: 1.8rem;
        font-weight: 500;
        line-height: 130%;
        display: inline-block;
        padding-left: 0.5rem;
        border-left: 0.6rem solid #3D90DD;
      }
      .unitar-right-btn{
        display: inline-flex;
        .unitar-bound-btn{
          display: inline-block;
          margin-right: 1.2rem;
          height: 3.2rem;
          width: 3.2rem;
          i{
            display: inline-block;
            height: 100%;
            width: 100%;
            svg{
              height: 100%;
              width: 100%;
            }
          }
        }
        .unitar-close-btn{
          display: inline-block;
          height: 3.2rem;
          width: 3.2rem;
          i{
            display: inline-block;
            height: 100%;
            width: 100%;
            svg{
              height: 100%;
              width: 100%;
            }
          }
        }
      }
    }
    .unitar-video-pop-body{
      display: flex;
      flex-direction: column;
      gap: 1.2rem;
      flex: 1;
      p{
        color: #4A4A4A;
        font-size: 1.2rem;
        font-weight: 400;
        line-height: 1.6rem; /* 133.333% */
      }
    }
  }
}
// Explore Popup
.unitar-explore-popup{
  position: relative;
  .unitar-explore-btn{
    display: inline-block;
    padding: 0.4rem 0.8rem;
    border-radius: 0.2rem;
    background: #F0F0F0;
    position: relative;
    margin-left: 1.6rem;
    display: inline-flex;
    align-items: center;
    border: 0.1rem solid transparent;
    
    span{
      color: #4A4A4A;
      font-size: 1.5rem;
      font-weight: 500;
      line-height: 2.4rem;
    }
    i{
      display: inline-block;
      height: 2.4rem;
      width: 2.4rem;
      svg{
        height: 100%;
        width: 100%;
      }
    }
    &.active{
      background-color: #E5F0FF;
      border-color: #6EAAE6;
      span{
        color: #3D90DD;
      }
      i{
        svg{
          path{
            stroke: #6EAAE6;
          }
        }
      }
    }
  }
  .unitar-explore-pop-wrapper{
    position: absolute;
    left: 1rem;
    top: 4rem;
    border-radius: 0.8rem;
    border: 0.1rem solid #6EAAE6;
    background: #FFF;
    width: 32.8rem;
    z-index: 1;
    .unitar-explore-card{
      padding: 1.6rem;
      display: flex;
      flex-direction: column;
      gap: 1.6rem;
      .unitar-explore-head{
        position: relative;
        p{
          color: #000;
          font-size: 1.4rem;
          font-weight: 400;
          line-height: 1.8rem;
        }
        .explore-close-btn{
          height: 1.4rem;
          width: 1.4rem;
          position: absolute;
          right: -0.2rem;
          top: -0.2rem;
          i{
            display: inline-block;
            height: 100%;
            width: 100%;
            svg{
              height: 100%;
              width: 100%;
            }
          }
        }
      }
      .unitar-explore-body{
        display: flex;
        flex-direction: column;
        .head{
          display: block;
          color: #000;
          font-size: 1.4rem;
          font-weight: 500;
          line-height: 1.8rem;
          margin-bottom: 0.8rem;
        }
        .list{
          .list-item{
            display: inline-flex;
            align-items: center;
            color: #000;
            font-size: 1.4rem;
            font-weight: 400;
            line-height: 1.8rem;
            i{
              display: inline-block;
              height: 1.8rem;
              width: 1.8rem;
              svg{
                height: 100%;
                width: 100%;
              }
            }
          }
        }
        .explore-country-btn{
          color: #3D90DD;
          font-size: 1.2rem;
          font-weight: 500;
          line-height: 1.8rem; /* 150% */
          text-decoration-line: underline;
          display: inline-flex;
          align-items: center;
          margin-top: 1.6rem;
          i{
            display: inline-block;
            height: 1.6rem;
            width: 1.6rem;
            svg{
              height: 100%;
              width: 100%;
            }
          }
        }
      }
      .unitar-explore-footer{
        text-align: right;
        .unitar-apply-btn{
          border-radius: 0.4rem;
          background: #3D90DD;
          padding: 1.2rem 2.4rem;
          color: #FFF;
          font-size: 1.6rem;
          font-weight: 500;
          line-height: 1.8rem;
          letter-spacing: 0.032rem;
        }
      }
    }
  }
}
`
export const HomeCardRow = styled.div`
     display:flex;
     gap:2rem;
     width:max-content;
`;
export const HomeCardCol = styled.div`
     width:22.4rem;
`;
export const HomeCard = styled.div`
     width:100%;
     background:#fff;
     border-radius:0.5rem;
     color:#4D4D4F;
     border:${({ isBorder }) => isBorder ? '0.1rem' : '0rem'} solid #3D90DD;
     padding:1.2rem;
     font-size: 1.5rem;
     font-style: normal;
     font-weight: 500;
     line-height: 150%;
`;
export const HomeCardImgDiv = styled.div`
  width:100%;
  height:10rem;
  display:flex;
  align-items:center;
  justify-content:center;
  background: #E2EEFA;
  margin-bottom:0.8rem;
  border-radius: 5px;
  position:relative;
  .status{
    border-radius: 25px;
    border: 1px solid #F1B1BB;
    background: #FFF;
    color:#DB324D;
    font-size:1.1rem;
    font-weight:600;
    line-height:120%;
    position:absolute;
    bottom:0.8rem;
    left:0.8rem;
    padding:0.3rem 1rem;
    display:block;
    &.blue{
      color:#2C55A0;
      border-color:#A6B8D7;
    }
  }
  svg{
    max-width:90%;
  }
`

export const SkillArrowSection = styled.div`
       display:flex;
       gap:1rem;
       padding:1.6rem 0rem 1.6rem 0.6rem;
       font-size: 1.2rem;
       font-weight: 400;
       line-height: 125%; 
       letter-spacing: 0.024rem;
       color:#1487E3;
       flex:1;
       svg{
        max-width:3rem;
       }
       h2{
        font-weight:600;
        font-size: 1.2rem;
        margin-bottom:0.6rem;
       }
       p{
        display:flex;
        gap:0.4rem;
        .num-span{
          min-width:1rem;
        }
        .num-text{
          flex:1;
        }
       }
       `